import axios from "axios";
import { PROFILE_IMAGE, UPDATE_USER } from "../api";

export async function uploadProfileImage(image, auth) {
  const formData = new FormData();
  formData.append("$auth", JSON.stringify(auth));
  formData.append("image", image);

  try {
    const response = await axios.post(PROFILE_IMAGE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status != 201) {
      throw new Error("Image upload failed");
    }

    // Handle successful response if needed
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function updateUser(data) {
  try {
    const response = await axios.patch(UPDATE_USER, data);
    if (response.status != 200) {
      throw new Error("Something went wrong.");
    }
    return true
    // Handle successful response if needed
  } catch (error) {
    console.error(error);
    throw error;
  }
}
